<template>
  <div class="location-list">
    <ul v-if="locations && locations.length" class="list">
      <li v-for="(location, index) in locations" :key="`${location.type}${location.id}`" class="item">
        <div v-if="index===0 && pagination.page === 1">
          <component :is="eventItemFirstComponent || eventItemComponent" v-if="isEvent(location)" :event="location" />
          <component :is="localChapterItemFirstComponent || localChapterItemComponent" v-if="isLocalGroup(location)" :local-group="location" />
        </div>
        <div v-else>
          <component :is="eventItemComponent" v-if="isEvent(location)" :event="location" />
          <component :is="localChapterItemComponent" v-if="isLocalGroup(location)" :local-group="location" />
        </div>
      </li>
    </ul>
    <!-- Before locations list has been loaded for the first time, it is null, so won't load this component.
         Afterwards, if it's empty, it'll be an empty array and load this component. -->
    <component :is="emptyListComponent" v-else-if="locations" :types-included="typesIncluded" />
    <div class="pagination-controls-container">
      <SimplePagination :initial-page="pagination.page"
                        :records="pagination.totalCount"
                        :per-page="pagination.perPage"
                        :total-pages="pagination.totalPages"
                        :chunk-number="5"
                        theme="public"
                        @paginate="onPaginate" />
    </div>
  </div>
</template>

<script>
import EmptyList from './empty-list'
import EventListItem from './event-list-item'
import LocalChapterListItem from './local-chapter-list-item'
import SimplePagination from '../components/simple-pagination'
import { mapState } from 'vuex'

export default {
  components: { EmptyList, EventListItem, LocalChapterListItem, SimplePagination },
  props: {
    locations: {
      type: Array,
      required: false
    },
    eventItemComponent: {
      type: Object,
      required: false,
      default: () => EventListItem
    },
    localChapterItemComponent: {
      type: Object,
      required: false,
      default: () => LocalChapterListItem
    },
    eventItemFirstComponent: {
      type: Object,
      required: false,
      default: null
    },
    localChapterItemFirstComponent: {
      type: Object,
      required: false,
      default: null
    },
    emptyListComponent: {
      type: Object,
      default: () => EmptyList
    }
  },

  emits: ['paginate'],

  computed: mapState({
    pagination: state => state.pagination,
    typesIncluded: state => {
      const typeFilter = state.filters.find(f => f.type === 'types')
      if (typeFilter) {
        return typeFilter.value
      }
      // both types are included
      return ['event', 'group']
    }
  }),

  methods: {
    isEvent: function(location) {
      return location.type === 'Event' || location.type === 'ExternalEvent'
    },

    isLocalGroup: function(location) {
      return location.type === 'Group'
    },
    onPaginate: function(page) {
      this.$store.dispatch('paginate', page)
      this.$emit('paginate')
    }
  }
}

</script>

<style lang="scss" scoped>
@use "~friendship_styles/colors" as colors;

$border: 8px solid #F5F5F5;

.location-list {
  flex: 1 0;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.pagination-controls-container {
  display:flex;
  justify-content: center;
  align-items: center;

  ::v-deep(ul.pagination-container) {
    .page-link {
      border: none;
      font-weight: bold;
      line-height: 30px;
      width: 42px;
      text-align: center;
    }

    .page-link.back-button {
      text-align: left;
    }

    .page-link.next-button {
      text-align: right;
    }

    > .disabled > a {
      color: colors.$unobtrusive-text-color;
    }
  }
}
</style>
